/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_Scene_Description_JobInputs */

const en_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Job`)
};

const fr_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre une offre d'emploi`)
};

const de_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job einreichen`)
};

const it_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia la tua offerta di lavoro`)
};

const ru_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить вакансию`)
};

const es_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar solicitud de empleo`)
};

const zh_cn2_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交职位`)
};

const ja_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求人情報を送信する`)
};

const hi_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी जमा करें`)
};

const pt_pt2_submit_scene_description_job = /** @type {(inputs: Submit_Scene_Description_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar vaga`)
};

/**
* | output |
* | --- |
* | "Submit Job" |
*
* @param {Submit_Scene_Description_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_scene_description_job = /** @type {((inputs?: Submit_Scene_Description_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Scene_Description_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submit_scene_description_job(inputs)
	if (locale === "de") return de_submit_scene_description_job(inputs)
	if (locale === "it") return it_submit_scene_description_job(inputs)
	if (locale === "ru") return ru_submit_scene_description_job(inputs)
	if (locale === "es") return es_submit_scene_description_job(inputs)
	if (locale === "zh-CN") return zh_cn2_submit_scene_description_job(inputs)
	if (locale === "ja") return ja_submit_scene_description_job(inputs)
	if (locale === "hi") return hi_submit_scene_description_job(inputs)
	if (locale === "pt-PT") return pt_pt2_submit_scene_description_job(inputs)
	return en_submit_scene_description_job(inputs)
});